export const VISUALIZATIONS_LIST_TABLE_HEADERS = [
  "",
  "Sr No.",
  "Name",
  "Version",
  "Total Charts",
  "Created On",
  "Created By",
  "Updated On",
  "Details",
  "Action",
];
